import baseLayer from "../components/layout/index.vue";
import pageLayer from "../components/layout/page.vue";
export const branchRoute = {
  path: "/branch",
  component: baseLayer,
  meta: {
    menuId: 2,
    level: 0
  },
  children: [{
    path: "/",
    redirect: "index"
  },
  {
    path: "index",
    name: "branch_home",
    component: pageLayer,
    meta: {
      elementId: "branch_home",
      level: 1
    },
    children: [{
      path: "/",
      name: "branch_index",
      meta: {
        elementId: "branch_index",
        level: 1
      },
      component: () => import("@/pages/branch/index")
    },
    // 校区搜索
    {
      path: "search/:content/:type?/:id?",
      name: "branch_search",
      // component: pageLayer,
      meta: {
        isSubPage: true,
        // root: "branch_index",
        menuName: "搜索"
      },
      component: () => import("@/pages/branch/branchSearch")
    },
    ]
  },


  //** 客户中心 */
  {
    name: "branch_customer",
    path: "customer",
    meta: {
      menuId: 2,
      level: 2
    },
    component: pageLayer,
    children: [{
      path: "own/mine",
      name: "branch_customer_own_mine",
      meta: {
        menuId: 2,
        level: 3
      },
      component: () => import("@/pages/branch/customer/own"),
    },
    {
      path: "own/myPerformance",
      name: "branch_customer_own_myPerformance",
      meta: {
        menuId: 2,
        level: 3
      },
      component: () => import("@/pages/branch/customer/own/myPerformance"),
    },
    {
      path: "own/subordinatePerformance",
      name: "branch_customer_own_subordinatePerformance",
      meta: {
        menuId: 2,
        level: 3
      },
      component: () => import("@/pages/branch/customer/own/subordinatePerformance"),
    },
    {
      path: "all",
      name: "branch_customer_all",
      meta: {
        menuId: 2,
        level: 3
      },
      component: () => import("@/pages/branch/customer/all")
    },
    {
      path: "common",
      name: "branch_customer_common",
      meta: {
        menuId: 2,
        level: 3
      },
      component: () => import("@/pages/branch/customer/common")
    },
    {
      path: "followupRecord",
      name: "branch_customer_followupRecord",
      meta: {
        menuId: 2,
        level: 3
      },
      component: () => import("@/pages/branch/customer/followupRecord")
    },
    {
      path: "expRecord",
      name: "branch_customer_expRecord",
      meta: {
        menuId: 2,
        level: 2
      },
      component: () =>
        import('@/pages/branch/customer/expRecord')
    },
    {
      path: "marketAnalysis/saleManagement",
      name: "branch_customer_marketAnalysis_saleManagement",
      meta: {
        menuId: 2,
        level: 3
      },
      component: () =>
        import('@/pages/branch/customer/marketAnalysis/saleManagement')
    },
    {
      path: "addCustomer",
      name: "branch_customerRecord_addCustomer",
      meta: {
        isSubPage: true,
        root: "branch_customer_marketAnalysis_customerRecord",
        menuName: "客户数量统计"
      },
      component: () =>
        import("@/pages/organization/customer/marketAnalysis/customerRecord/addCustomer")
    },
    {
      path: "branchCount",
      name: "branch_customerRecord_branchCount",
      meta: {
        isSubPage: true,
        root: "branch_customer_marketAnalysis_customerRecord",
        menuName: "校区客户数量对比"
      },
      component: () =>
        import("@/pages/organization/customer/marketAnalysis/customerRecord/branchCount")
    },
    {
      path: "customerCount",
      name: "branch_customerRecord_customerCount",
      meta: {
        isSubPage: true,
        root: "branch_customer_marketAnalysis_customerRecord",
        menuName: "销售人员客户数量对比"
      },
      component: () =>
        import("@/pages/organization/customer/marketAnalysis/customerRecord/customerCount")
    },

    {
      path: "marketAnalysis/customerRecord",
      name: "branch_customer_marketAnalysis_customerRecord",
      meta: {
        menuId: 2,
        level: 3
      },
      component: () =>
        import('@/pages/organization/customer/marketAnalysis/customerRecord')
    },

    {
      path: "marketAnalysis/expTransformation",
      name: "branch_customer_marketAnalysis_expTransformation",
      meta: {
        menuId: 2,
        level: 3
      },
      component: () =>
        import('@/pages/organization/customer/marketAnalysis/expTransformation/index.vue')
    },
    {
      path: "expRecord/:type",
      name: "branch_expTransformation_expRecord",
      meta: {
        isSubPage: true,
        root: "branch_customer_marketAnalysis_expTransformation",
        menuName: "体验记录统计"
      },
      component: () =>
        import("@/pages/organization/customer/marketAnalysis/expTransformation/transferDetail")
    },
    {
      path: "expTeacher/:type",
      name: "branch_expTransformation_expTeacher",
      meta: {
        isSubPage: true,
        root: "branch_customer_marketAnalysis_expTransformation",
        menuName: "体验课任课老师统计"
      },
      component: () =>
        import("@/pages/organization/customer/marketAnalysis/expTransformation/transferDetail")
    },
    {
      path: "expOrgUser/:type",
      name: "branch_expTransformation_expOrgUser",
      meta: {
        isSubPage: true,
        root: "branch_customer_marketAnalysis_expTransformation",
        menuName: "体验课经办人统计"
      },
      component: () =>
        import("@/pages/organization/customer/marketAnalysis/expTransformation/transferDetail")
    },
    {
      path: "expCourse/:type",
      name: "branch_expTransformation_expCourse",
      meta: {
        isSubPage: true,
        root: "branch_customer_marketAnalysis_expTransformation",
        menuName: "体验课程统计"
      },
      component: () =>
        import("@/pages/organization/customer/marketAnalysis/expTransformation/transferDetail")
    },

    {
      path: "marketAnalysis/signUpOrder",
      name: "branch_customer_marketAnalysis_signUpOrder",
      meta: {
        menuId: 2,
        level: 3
      },
      component: () =>
        import('@/pages/organization/customer/marketAnalysis/signUpOrder/index.vue')
    },
    {
      path: "order/:type",
      name: "branch_signUpOrder_order",
      meta: {
        isSubPage: true,
        root: "branch_customer_marketAnalysis_signUpOrder",
        menuName: "报名订单统计"
      },
      component: () =>
        import("@/pages/organization/customer/marketAnalysis/signUpOrder/signUpDetail")
    },
    {
      path: "sale/:type",
      name: "branch_signUpOrder_sale",
      meta: {
        isSubPage: true,
        root: "branch_customer_marketAnalysis_signUpOrder",
        menuName: "销售人员成交单量统计"
      },
      component: () =>
        import("@/pages/organization/customer/marketAnalysis/signUpOrder/signUpDetail")
    },
    {
      path: "course/:type",
      name: "branch_signUpOrder_course",
      meta: {
        isSubPage: true,
        root: "branch_customer_marketAnalysis_signUpOrder",
        menuName: "课程报名量对比"
      },
      component: () =>
        import("@/pages/organization/customer/marketAnalysis/signUpOrder/signUpDetail")
    },
    ]
  },
  //** 营销中心 */
  {
    name: "branch_marketing",
    path: "marketing",
    meta: {
      menuId: 2,
      level: 1
    },
    component: pageLayer,
    children: [
      {
        path: "analysis/reservation",
        name: "branch_marketing_analysis_reservation",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/organization/miniApp/analyse/reservation"),
      },
      {
        path: "analysis/activity",
        name: "branch_marketing_analysis_activity",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/organization/miniApp/analyse/activity"),
      },
      {
        path: "marketingData/coupon",
        name: "branch_marketing_marketingData_coupon",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/marketing/marketingData/coupon"),
      },
      {
        path: "marketingData/orderManage",
        name: "branch_marketing_marketingData_orderManage",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/marketing/marketingData/orderManage"),
      },
      {
        path: "marketingData/reservationList",
        name: "branch_marketing_marketingData_reservationList",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/marketing/marketingData/reservationList"),
      },
      {
        path: "marketingData/recommendList",
        name: "branch_marketing_marketingData_recommendList",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/organization/miniApp/marketingData/recommendList"),
      },
      {
        path: "homepage/:type",
        name: "branch_marketing_homepage",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () =>
          import('@/pages/branch/marketing/homepage')
      },
      {
        path: "bargain/mine",
        name: "branch_marketing_bargain_mine",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () =>
          import('@/pages/branch/marketing/bargain/mine')
      },
      {
        path: "auditions",
        name: "branch_marketing_auditions",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () =>
          import('@/pages/branch/marketing/auditions')
      },
      {
        path: "mall",
        name: "branch_miniApp_mall",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () =>
          import("@/pages/organization/miniApp/mall")
      },

      //改版前
      {
        path: "bargain/mine",
        name: "branch_marketing_mine",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/marketing/bargain/mine")
      }, {
        path: "bargain/mineform",
        name: "branch_marketing_mineform",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/marketing/bargain/mine/mineform")
      },
      {
        path: "bargain/mine/edit/:activityId",
        name: "branch_marketing_mine_edit",
        meta: {
          isSubPage: true,
          root: "branch_marketing_bargain_mine",
          menuName: '砍价活动'
        },
        component: () => import("@/pages/organization/miniApp/marketing/bargain/edit")
      },
      {
        path: "bargain/model",
        name: "branch_marketing_model",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/marketing/bargain/model")
      },
      {
        path: "auditions/mine",
        name: "branch_marketing_auditionsmine",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/marketing/auditions")
      }, {
        path: "auditions/mineform",
        name: "branch_marketing_auditionsmineform",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/marketing/auditions/form/auditionform")
      },
      {
        path: "auditions/model/:mode/:id",
        name: "branch_marketing_auditionsmodel",
        meta: {
          isSubPage: true,
          root: "branch_marketing_auditions",
          menuName: '体验课制作'
        },
        component: () => import("@/pages/organization/miniApp/marketing/auditions/addModel")
      },
      {
        path: "auditions/model",
        name: "branch_marketing_auditionsmodel",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/marketing/auditions/model")
      },
      {
        path: "coupon",
        name: "branch_marketing_coupon",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/marketing/coupon")
      }
    ]
  },
  //** 办理中心 */
  {
    name: "branch_handle",
    path: "handle",
    meta: {
      menuId: 2,
      level: 1
    },
    component: pageLayer,
    redirect: "handle/control",
    children: [{
      path: "control",
      name: "branch_handle_control",
      meta: {
        menuId: 2,
        level: 2
      },
      component: () => import('@/pages/branch/handle/control')
    },
    {
      path: "control/endclass",
      name: 'branch_handle_control_endclass',
      meta: {
        menuId: 2,
        level: 3
      },
      component: () =>
        import('@/pages/branch/handle/endclass')
    },
    {
      path: "control/resumeclass",
      name: 'branch_handle_control_resumeclass',
      meta: {
        menuId: 2,
        level: 3
      },
      component: () =>
        import('@/pages/branch/handle/resumeclass')
    },
    {
      path: "control/executClassLog/:idStu?/:idCour?",
      name: 'branch_handle_control_executClassLog',
      meta: {
        menuId: 2,
        level: 3
      },
      component: () =>
        import('@/pages/branch/handle/executClassLog')
    },
    {
      path: "control/enroll/:CourseId/:StudentId",
      name: "branch_handle_control_enroll",
      meta: {
        isSubPage: true,
        root: "branch_handle_control",
        menuName: '报名/续费'
      },
      component: () => import('@/pages/branch/handle/enroll')
    },
    {
      path: "control/transferClass",
      name: "branch_handle_control_transferClass",
      meta: {
        isSubPage: true,
        root: "branch_handle_control",
        menuName: '转班'
      },
      component: () => import('@/pages/branch/handle/transferClass')
    },
    {
      path: "control/transferClass/:CourseId/:StudentId",
      name: "branch_handle_control_transferClass",
      meta: {
        isSubPage: true,
        root: "branch_handle_control",
        menuName: '转班'
      },
      component: () => import('@/pages/branch/handle/transferClass')
    },
    {
      path: "control/transferClassMulti",
      name: "branch_handle_control_transferClassMulti",
      meta: {
        isSubPage: true,
        root: "branch_handle_control",
        menuName: '批量转班'
      },
      component: () => import('@/pages/branch/handle/transferClassMulti')
    },
    {
      path: "control/renewal",
      name: "branch_handle_control_renewal",
      meta: {
        menuId: 2,
        level: 2
      },
      component: () => import('@/pages/branch/insurance')
    },
    {
      path: "control/repay/:stuId",
      name: "branch_handle_control_repay",
      meta: {
        isSubPage: true,
        root: "branch_handle_control",
        menuName: '补交'
      },
      component: () => import('@/pages/branch/handle/repay')
    },
    {
      path: "control/refund/:courId/:stuId",
      name: "branch_handle_control_refund",
      meta: {
        isSubPage: true,
        root: "branch_handle_control",
        menuName: '退费'
      },
      component: () => import('@/pages/branch/handle/refund')
    },
    {
      path: "control/renewalWarning",
      name: 'branch_handle_control_renewalWarning',
      meta: {
        // isSubPage: true,
        // root: 'branch_handle_control'
        menuId: 2,
        level: 2
      },
      component: () =>
        import('@/pages/branch/handle/renewalWarning')
    },
    {
      path: "control/activateRide",
      name: 'branch_handle_control_activateRide',
      meta: {
        menuId: 2,
        level: 2
      },
      component: () =>
        import('@/pages/branch/handle/activateRide')
    },
    {
      path: "control/endOrresumeclass", //停课复课切换
      name: 'branch_handle_control_endOrresumeclass',
      meta: {
        menuId: 2,
        level: 2
      },
      component: () =>
        import('@/pages/branch/handle/endOrresumeclass')
    },
    ]
  },
  //** 内部管理 */
  {
    path: "internal",
    name: "branch_internal",
    meta: {
      menuId: 2,
      level: 2
    },
    component: pageLayer,
    children: [{
      path: "user",
      name: "branch_internal_user",
      meta: {
        menuId: 2,
        level: 3
      },
      component: () => import("@/pages/branch/internal/user")
    },
    {
      path: "site",
      name: "branch_internal_site",
      meta: {
        menuId: 2,
        level: 3
      },
      component: () => import("@/pages/branch/internal/site")
    },
    {
      path: "order",
      name: "branch_internal_order",
      meta: {
        menuId: 2,
        level: 3
      },
      component: () => import("@/pages/branch/internal/order")
    },
      // {
      //   path: "commodity/goods",
      //   name: "branch_internal_commodity_goods",
      //   meta: {
      //     menuId: 2,
      //     level: 3
      //   },
      //   component: () => import("@/pages/organization/hr/commodity/goods")
      // },
      // {
      //   path: "commodity/type",
      //   name: "branch_internal_commodity_type",
      //   meta: {
      //     menuId: 2,
      //     level: 3
      //   },
      //   component: () => import("@/pages/organization/hr/commodity/type")
      // },

      // {
      //   path: "order",
      //   name: "branch_internal_order",
      //   meta: { menuId: 2, level: 3 },
      //   component: () => import("@/pages/branch/internal/order")
      // }
    ]
  },
  //商品管理
  {
    name: "branch_commodity",
    path: "commodity",
    meta: {
      menuId: 2,
      level: 1
    },
    component: pageLayer,
    children: [{
      path: "goods",
      name: "branch_commodity_goods",
      meta: {
        menuId: 2,
        level: 2
      },
      component: () => import("@/pages/organization/hr/commodity/goods")
    }, {
      path: "type",
      name: "branch_commodity_type",
      meta: {
        menuId: 2,
        level: 2
      },
      component: () => import("@/pages/organization/hr/commodity/type")
    }, {
      path: "package",
      name: "branch_commodity_package",
      meta: {
        menuId: 2,
        level: 2
      },
      component: () => import("@/pages/branch/internal/package")
    },]
  },
  //** 系统设置 */
  {
    name: "branch_baseSet",
    path: "baseSet",
    meta: {
      menuId: 2,
      level: 2
    },
    component: pageLayer,
    children: [{
      path: "holiday",
      name: "branch_baseSet_holiday",
      meta: {
        menuId: 2,
        level: 3
      },
      component: () => import("@/pages/branch/educational/holiday")
    }, {
      path: "WXSetting",
      name: "branch_baseSet_WXSetting",
      meta: {
        menuId: 2,
        level: 3
      },
      component: () => import("@/pages/organization/baseSetting/WXSetting")
    },]
  },
  //** 教务中心 */
  {
    name: "branch_educational",
    path: "educational",
    meta: {
      menuId: 2,
      level: 2
    },
    component: pageLayer,
    children: [
      {
        path: "classhourlist", // 课时列表  排课（就是课时列表）
        name: "branch_educational_classhourlist",
        meta: {
          menuId: 1,
          level: 2
        },
        component: () => import('@/pages/organization/handle/classHourList')
      }, {
        path: "prepare/:scheduleId", // 备课
        name: "branch_educational_prepare",
        meta: {
          isSubPage: true,
          root: "branch_educational_classhourlist",
          menuName: '备课'
        },
        component: () => import('@/pages/branch/educational/prepare/index.vue')
      },
      {
        path: "homework/:scheduleId", // 布置作业
        name: "branch_educational_homework",
        meta: {
          isSubPage: true,
          root: "branch_educational_classhourlist",
          menuName: '布置作业'
        },
        component: () => import('@/pages/branch/educational/homework/index.vue')
      },
      {
        path: "homeworklist", // 作业管理
        name: "branch_educational_homeworklist",
        meta: {
          isSubPage: true,
          root: "branch_educational_dailywork",
          menuName: '布置作业'
        },
        component: () => import('@/pages/branch/educational/homework/homeworkList.vue')
      },
      {
        path: "outdatelist", // 过期票卡
        name: "branch_educational_outdatelist",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import('@/pages/branch/educational/outdatelist/index.vue')
      },
      {
        path: "classlog/:isAdd/:scheduleId/:courseId/:classId/:saleMethod/:deductCount",
        name: "branch_educational_classlog",
        meta: {
          isSubPage: true,
          root: "branch_educational_classhourlist",
          menuName: '记上课'
        },
        component: () => import("@/pages/organization/handle/classHourList/classLog")
      },
      // {
      //   path: "classlogrecord/:isAdd/:scheduleId/:courseId/:classId/:saleMethod/:deductCount",
      //   name: "branch_educational_classlogrecord",
      //   meta: {
      //     isSubPage: true,
      //     root: "branch_educational_student_archeives",
      //     menuName:'记上课'
      //   },
      //   component: () => import("@/pages/organization/handle/classHourList/classLog")
      // },
      {
        path: "course",
        name: "branch_educational_course",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/educational/course")
      },
      {
        path: "currencyCard",
        name: "branch_educational_currencyCard",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/educational/currencyCard")
      }, {
        path: "student",
        name: "branch_educational_student",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/educational/student")
      },
      {
        path: "myStudent",
        name: "branch_educational_myStudent",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/educational/student/myStudent")
      },
      {
        path: "student/classlog/:isAdd/:scheduleId/:courseId/:classId/:saleMethod/:deductCount",
        name: "branch_educational_studentclasslog",
        meta: {
          isSubPage: true,
          root: "branch_educational_classhourlist",
          menuName: '记上课'
        },
        component: () => import("@/pages/organization/handle/classHourList/classLog")
      },
      {
        path: "student/:StudentId",
        name: "branch_educational_student_archeives",
        meta: {
          isSubPage: true,
          root: "branch_educational_student",
          menuName: '学员档案'
        },
        component: () => import("@/pages/branch/educational/student/archives")
      },
      {
        path: "class",
        name: "branch_educational_class",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/educational/class"),
        props: (route) => ({ query: route.query.isExistsSchedule })
      },
      {
        path: "stuExecutionLog",
        name: "branch_educational_stuExecutionLog",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/educational/stuExecutionLog")
      },
      {
        path: "class/:classId",
        name: "branch_educational_class_detail",
        meta: {
          isSubPage: true,
          root: "branch_educational_class",
          menuName: '班级详情'
        },
        component: () =>
          import("@/pages/branch/educational/class/detail/index")
      },
      {
        path: "class/classlog/:isAdd/:scheduleId/:courseId/:classId/:saleMethod/:deductCount",
        name: "branch_educational_class_detail_classlog",
        meta: {
          isSubPage: true,
          root: "branch_educational_class",
          menuName: '记上课'
        },
        component: () => import("@/pages/organization/handle/classHourList/classLog")
      },
      {
        path: "holiday",
        name: "branch_educational_holiday",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/educational/holiday")
      },
      {
        path: "dailywork",
        name: "branch_educational_dailywork",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/educational/dailyWork")
      },
      {
        path: "leaveRecordStudent",
        name: "branch_educational_leaveRecordStudent",
        meta: {
          isSubPage: true,
          root: "branch_educational_dailywork",
          menuName: '学员请假审批'
        },
        component: () => import("@/pages/branch/educational/leaveRecordStudent")
      },
      {
        path: "leaveRecordTeacher",
        name: "branch_educational_leaveRecordTeacher",
        meta: {
          isSubPage: true,
          root: "branch_educational_dailywork",
          menuName: '教师请假审批'
        },
        component: () => import("@/pages/branch/educational/leaveRecordTeacher")
      },
      {
        path: "leaveClassRecord",
        name: "branch_educational_leaveClassRecord",
        meta: {
          isSubPage: true,
          root: "branch_educational_dailywork",
          menuName: '请假补课记录'
        },
        component: () => import("@/pages/branch/educational/leaveClassRecord")
      },
      {
        path: "undividedStudent",
        name: "branch_educational_undividedStudent",
        meta: {
          isSubPage: true,
          root: "branch_educational_dailywork",
          menuName: '未分班学员'
        },
        component: () => import("@/pages/branch/educational/undividedStudent")
      },
      {
        path: 'unmatchdStudent',
        name: 'branch_educational_unmatchedStudent',
        meta: {
          isSubPage: true,
          root: 'branch_educational_dailywork',
          menuName: '长期未上课学员'
        },
        component: () => import('@/pages/branch/educational/unmatchStudent')
      },
      {
        path: "classReview",
        name: "branch_educational_classReview",
        meta: {
          isSubPage: true,
          root: "branch_educational_dailywork",
          menuName: '课时点评'
        },
        component: () => import("@/pages/branch/educational/classReview")
      },
      {
        path: "retroactive",
        name: "branch_educational_retroactive",
        meta: {
          isSubPage: true,
          root: "branch_educational_dailywork",
          menuName: '老师打卡补签'
        },
        component: () => import("@/pages/branch/educational/retroactive")
      },
      {
        path: "classrecord",
        name: "branch_educational_classrecord",
        meta: {
          isSubPage: true,
          root: "branch_educational_dailywork",
          menuName: '上课记录'
        },
        component: () => import("@/pages/branch/educational/classRecord")
      },
      {
        path: "cardChangeRecord",
        name: "branch_educational_cardChangeRecord",
        meta: {
          isSubPage: true,
          root: "branch_educational_dailywork",
          menuName:'调整记录'
        },
        component: () => import("@/pages/branch/educational/cardChangeRecord")
      },
      {
        path: "classSchedule",
        name: "branch_educational_classSchedule",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/educational/classSchedule")
      },
      {
        path: "evaluatepackage",
        name: "branch_educational_evaluatepackage",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/educational/evaluatePackage")
      },
      // 磁卡签到
      {
        path: "idCardStu",
        name: "branch_educational_idCardStu",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/educational/idCard/indexStu.vue")
      },
      // 忘带磁卡
      {
        path: "forgetCard",
        name: "branch_educational_forgetCard",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/educational/idCard/forgetCard.vue")
      },
      // 查找学员
      {
        path: "searchCard",
        name: "branch_educational_searchCard",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/educational/idCard/searchCard.vue")
      },
      // 打卡记录
      {
        path: "cardLog",
        name: "branch_educational_cardLog",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/educational/idCard/cardLog.vue")
      },
      // 磁卡签到设置
      {
        path: "cardSetting",
        name: "branch_educational_cardSetting",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/educational/idCard/cardSetting.vue")
      },
      {
        path: "noClassScheduleAttend",
        name: "branch_educational_noClassScheduleAttend",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () => import("@/pages/branch/educational/noClassScheduleAttend")
      }
    ]
  },
  //**米粒家 */
  {
    path: 'home',
    meta: {
      menuId: 2,
      level: 1
    },
    name: 'branch_home',
    component: pageLayer,
    children: [{
      path: "announcement",
      name: "branch_home_announcement",
      meta: {
        menuId: 2,
        level: 2
      },
      component: () => import('@/pages/branch/home/announcements')
    },
    {
      path: "modelPage",
      name: "branch_home_modelpage",
      meta: {
        isSubPage: true,
        root: 'branch_home_announcement',
        menuName: '通知模板'
      },
      component: () => import('@/pages/branch/home/announcements/modelPage')
    },
    {
      path: "modelEdit/:modelId/:useModel?",
      name: "branch_home_modeledit",
      meta: {
        isSubPage: true,
        root: 'branch_home_announcement',
        menuName: '模板'
      },
      component: () => import('@/pages/branch/home/announcements/editPage')
    }
    ]
  },
  //** 数据中心 */
  {
    path: "dataAnalyse",
    meta: {
      menuId: 2,
      level: 1
    },
    name: 'branch_dataAnalyse',
    component: pageLayer,
    children: [{
      path: "fianacial",
      name: "branch_dataAnalyse_fianacial",
      meta: {
        menuId: 2,
        level: 2
      },
      component: () => import('@/pages/organization/dataCenter/financialData')
    },
    {
      path: "schoolAllMoney",
      name: "branch_dataAnalyse_schoolAllMoney",
      meta: {
        isSubPage: true,
        root: 'branch_dataAnalyse_fianacial',
        menuName: '校区应收详情'
      },
      component: () => import('@/pages/organization/dataCenter/financialData/schoolAllMoney')
    },
    {
      path: "schoolHasMoney",
      name: "branch_dataAnalyse_schoolHasMoney",
      meta: {
        isSubPage: true,
        root: 'branch_dataAnalyse_fianacial',
        menuName: '校区实收详情'
      },
      component: () => import('@/pages/organization/dataCenter/financialData/schoolHasMoney')
    },
    {
      path: "courseEndMoney",
      name: "branch_dataAnalyse_courseEndMoney",
      meta: {
        isSubPage: true,
        root: 'branch_dataAnalyse_fianacial',
        menuName: '课消收入详情'
      },
      component: () => import('@/pages/organization/dataCenter/financialData/courseEndMoney')
    },
    {
      path: "lastMoney",
      name: "branch_dataAnalyse_lastMoney",
      meta: {
        isSubPage: true,
        root: 'branch_dataAnalyse_fianacial',
        menuName: '剩余学费详情'
      },
      component: () => import('@/pages/organization/dataCenter/financialData/lastMoney')
    },
    {
      path: "educational",
      name: "branch_dataAnalyse_educational",
      meta: {
        menuId: 2,
        level: 2
      },
      component: () =>
        import("@/pages/organization/dataCenter/educationalData")
    },
    {
      path: "teachClass",
      name: "branch_dataAnalyse_teachClass",
      meta: {
        isSubPage: true,
        root: "branch_dataAnalyse_educational",
        menuName: "授课课时详情"
      },
      component: () =>
        import("@/pages/organization/dataCenter/educationalData/teachClass")
    },
    {
      path: "studentAttend",
      name: "branch_dataAnalyse_studentAttend",
      meta: {
        isSubPage: true,
        root: "branch_dataAnalyse_educational",
        menuName: "学员出勤详情"
      },
      component: () =>
        import("@/pages/organization/dataCenter/educationalData/studentAttend")
    },
    {
      path: "teacherRate",
      name: "branch_dataAnalyse_teacherRate",
      meta: {
        isSubPage: true,
        root: "branch_dataAnalyse_educational",
        menuName: "老师评分详情"
      },
      component: () =>
        import("@/pages/organization/dataCenter/educationalData/teacherRate")
    },
    {
      path: "teacherAttend",
      name: "branch_dataAnalyse_teacherAttend",
      meta: {
        isSubPage: true,
        root: "branch_dataAnalyse_educational",
        menuName: "老师出勤详情"
      },
      component: () =>
        import("@/pages/organization/dataCenter/educationalData/teacherAttend")
    },
    {
      path: "sale",
      name: "branch_dataAnalyse_sale",
      meta: {
        menuId: 2,
        level: 2
      },
      component: () => import('@/pages/organization/dataCenter/saleData')
    },
    {
      path: "saleFunnel",
      name: "branch_dataAnalyse_saleFunnel",
      meta: {
        isSubPage: true,
        root: "branch_dataAnalyse_sale",
        menuName: "销售漏斗详情"
      },
      component: () =>
        import("@/pages/organization/dataCenter/saleData/saleFunnel")
    },
    {
      path: "saleData",
      name: "branch_dataAnalyse_saleData",
      meta: {
        isSubPage: true,
        root: "branch_dataAnalyse_sale",
        menuName: "销售数据详情"
      },
      component: () =>
        import("@/pages/organization/dataCenter/saleData/saleData")
    },
    {
      path: "customer",
      name: "branch_dataAnalyse_customer",
      meta: {
        isSubPage: true,
        root: "branch_dataAnalyse_sale",
        menuName: "客户占比详情"
      },
      component: () =>
        import("@/pages/organization/dataCenter/saleData/customer")
    }
    ]
  },
  // 仓库
  {
    path: "repertory",
    meta: {
      menuId: 2,
      level: 1
    },
    name: "branch_repertory",
    component: pageLayer,
    children: [
      {
        path: "intimeStock",
        name: "branch_repertory_intimeStock",
        meta: {
          menuId: 2,
          level: 2
        },
        component: () =>
          import("@/pages/organization/goods/repertory/intimeStock.vue")
      },
      {
        path: "branchpurchase",
        name: "branch_repertory_branchpurchase",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () =>
          import("@/pages/organization/goods/repertory/branchPurchase")
      },
      {
        path: "buygoods",
        name: "branch_repertory_buygoods",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () =>
          import("@/pages/organization/goods/repertory/buygoods")
      },
      {
        path: "reportloss",
        name: "branch_repertory_reportloss",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () =>
          import("@/pages/organization/goods/repertory/loss")
      },
      {
        path: "adjustment",
        name: "branch_repertory_adjustment",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () =>
          import("@/pages/organization/goods/repertory/adjustment")
      },
      {
        path: "branchtransfer",
        name: "branch_repertory_branchtransfer",
        meta: {
          menuId: 2,
          level: 3
        },
        component: () =>
          import("@/pages/organization/goods/repertory/transfer")
      },
      {
        path: "inoutlog",
        name: "branch_repertory_inoutlog",
        meta: {
          menuId: 2,
          level: 2
        },
        component: () =>
          import("@/pages/organization/goods/repertory/inoutLog.vue")
      },
      {
        path: "stockAlteration",
        name: "branch_repertory_stockAlteration",
        meta: {
          menuId: 2,
          level: 2
        },
        component: () =>
          import("@/pages/organization/goods/repertory/stockAlteration.vue")
      },
      {
        path: "setting",
        name: "branch_repertory_setting",
        meta: {
          menuId: 2,
          level: 2
        },
        component: () =>
          import("@/pages/organization/goods/repertory/setting.vue")
      },
    ]
  }
  ]
};



// WEBPACK FOOTER //
// ./src/router/branchRoute.js